import React from 'react';

const LENS_FILL = '#E1F4D3';  
const STROKE_COLOR = '#1B452A'; 

export const SearchIcon = ({ fill, width = 24, height = 24, className }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 53 53"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M24.2456 47.8844C27.3499 47.8844 30.4238 47.273 33.2919 46.085C36.1599 44.897 38.7658 43.1558 40.9609 40.9607C43.156 38.7656 44.8973 36.1596 46.0853 33.2916C47.2732 30.4236 47.8847 27.3496 47.8847 24.2453C47.8847 21.141 47.2732 18.067 46.0853 15.199C44.8973 12.331 43.156 9.72503 40.9609 7.52994C38.7658 5.33484 36.1599 3.5936 33.2919 2.40562C30.4238 1.21764 27.3499 0.606201 24.2456 0.606201C17.9761 0.606201 11.9634 3.09674 7.53018 7.52994C3.09699 11.9631 0.606445 17.9758 0.606445 24.2453C0.606445 30.5148 3.09699 36.5275 7.53018 40.9607C11.9634 45.3939 17.9761 47.8844 24.2456 47.8844Z"
        fill={fill || LENS_FILL}
      />
      <path
        d="M24.8513 1.81842C37.5801 1.81842 47.8843 12.1227 47.8843 24.8514C47.8843 37.5802 37.5801 47.8844 24.8513 47.8844C12.1226 47.8844 1.81836 37.5802 1.81836 24.8514C1.81836 15.8807 6.93411 8.12219 14.4259 4.31568M50.3089 50.3089L45.4598 45.4599"
        stroke={STROKE_COLOR}
        strokeWidth="3.63679"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};